export default "__VITE_ASSET__2149d19b__"